import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Button, Grid, Header, Icon, Breadcrumb, Segment, Input } from 'semantic-ui-react';
import moment from 'moment';

type SimplePageBarProps = {
    handlePrevActive: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    handleNextActive: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    hasPrev: boolean;
    hasNext: boolean;

};


export const SimplePageBar: React.FC<SimplePageBarProps> = ({handlePrevActive, handleNextActive,  hasPrev, hasNext } ) => {
    return (
        <div className='pagination-btn-container'>
            <Button icon labelPosition='left' size='small' 
                disabled={!hasPrev}
                className='pagination-btn' onClick={(e)=>{handlePrevActive(e)}}>
                Previous
                <Icon name='arrow left' />
            </Button>
            <Button icon labelPosition='right' size='small' 
                disabled={!hasNext}
                className='pagination-btn' onClick={(e)=>{handleNextActive(e)}}>
                Next
                <Icon name='arrow right' />
            </Button>
        </div>
    );

}